import { IFolder } from "../../Interfaces/IFolder";
import { IPage } from "../../Interfaces/IPage";

export enum PagesActionType {
  ADD_PAGE = 'ADD_PAGE',
  REMOVE_PAGE = 'REMOVE_PAGE',
  ADD_FOLDER = 'ADD_FOLDER'
}

export type PagesAction = IAddPageAction | IRemovePageAction | IAddFolderAction;

export interface IAddPageAction {
  page?: IPage;
  type: PagesActionType.ADD_PAGE;
}

export interface IRemovePageAction {
  page?: IPage;
  type: PagesActionType.REMOVE_PAGE;
}

export interface IAddFolderAction {
  folder?: IFolder;
  type: PagesActionType.ADD_FOLDER;
}
